import { createRequestTypes } from '../utils';

export const SUBSTANCE_PROPORTION_LIST = createRequestTypes('substanceProportion/SUBSTANCE_PROPORTION_LIST');
export const ADD_SUBSTANCE_PROPORTION = 'substanceProportion/ADD_SUBSTANCE_PROPORTION';
export const EDIT_SUBSTANCE_PROPORTION = 'substanceProportion/EDIT_SUBSTANCE_PROPORTION';
export const SAVE_SUBSTANCE_PROPORTION = createRequestTypes('substanceProportion/SAVE_SUBSTANCE_PROPORTION');
export const DELETE_SUBSTANCE_PROPORTION = createRequestTypes('substanceProportion/DELETE_SUBSTANCE_PROPORTION');
